import { Link } from "react-router-dom";
import Logo from "../assets/img/skor-white-logo.svg";
import Flag from "../assets/img/flag.svg";
import downIcon from "../assets/img/down-icon-dark.svg";
import Cancelimg from "../assets/img/cancel-01.svg";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import QRCode from "react-qr-code";
import { FaRegCopy } from "react-icons/fa6";
import { PhoneInput } from "react-international-phone";

const DummyHeader = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [isShareProfileModal, setIsShareProfileModal] = useState(false);
  const [shareQrModal, setShareQrModal] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showSharedModal, setShowSharedModal] = useState(false);
  const [currentLang, setCurrentLang] = useState("en-us");
  const [sharerEmail, setSharerEmail] = useState("");
  const [sharerPhone, setSharePhone] = useState("");
  const [sharerName, setSharerName] = useState("");
  const [unreadCount] = useState(0);

  return (
    <>
      <nav class="navbar navbar-expand-lg navbar-light position-static">
        <div class="container container-fluid navbar-container">
          <div className="row" style={{ alignItems: "center", width: "100%" }}>
            <div className="col-md-1 navbarLogoWrapper">
              <Link to="/">
                <img src={Logo} alt="Skor Logo" style={{ height: "2.024vw" }} />
              </Link>
            </div>

            <div className="col hideOnMobile p-0">
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item d-flex align-items-center">
                    <div>
                      <Link className="d-flex align-items-center megadropdown-toggle">
                        Skor Report
                      </Link>
                    </div>

                    <div>
                      <Link className="d-flex align-items-center megadropdown-toggle">
                        Property Payments
                      </Link>
                    </div>

                    <div>
                      <Link
                        id="shareProfileLink"
                        className="d-flex align-items-center megadropdown-toggle"
                        onClick={() => setIsShareProfileModal(true)}
                      >
                        Share Profile
                      </Link>
                    </div>

                    <div>
                      <Link className="d-flex align-items-center megadropdown-toggle">
                        Kelify
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-5 d-flex language-switch-wrapper">
              {currentLang === "es" ? (
                <div
                  className="language-switch-container language-switch-container-es hideOnMobile cursor-pointer"
                  onClick={() => setCurrentLang("en-us")}
                >
                  <p>ES</p>
                  <img
                    className="flag-image"
                    alt="Flag"
                    src="/images/spain-flag.png"
                  />
                </div>
              ) : (
                <div
                  className="language-switch-container hideOnMobile cursor-pointer"
                  onClick={() => setCurrentLang("es")}
                >
                  <img className="flag-image" alt="Flag" src={Flag} />
                  <p>EN</p>
                </div>
              )}

              <div className="bell-icon-wrapper hideOnMobile">
                <img src="/images/bell-icon-black.svg" alt="Bell Icon" />
                <span className="badge text-white">{unreadCount}</span>
              </div>

              <div className="slideryt">
                <div className="re-div">
                  <div className="dropdown admin-btn">
                    <Link data-bs-toggle="dropdown">
                      <div className="d-flex">
                        <div className="admin-name header-admin-name">TU</div>
                        <img src={downIcon} alt="arrow-down" className="ms-2" />
                      </div>

                      <ul
                        className="dropdown-menu header-mobile-dropdown"
                        data-bs-auto-close="inside"
                      >
                        <div
                          className="hover-dropdown-mobile hover-dropdown"
                          style={{ display: "block" }}
                        >
                          <Link>
                            <img src="/images/edit-icon-white.svg" alt="" />{" "}
                            Edit Profile
                          </Link>

                          <Link onClick={() => setShowModal(true)}>
                            <img src="/images/logout-icon.svg" alt="" /> Logout
                          </Link>

                          <div
                            className="language-switch-mobile pb-0 hideOnDesktop"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {currentLang === "es" ? (
                              <div
                                className="language-switch-container language-switch-container-es cursor-pointer"
                                onClick={() => setCurrentLang("en-us")}
                              >
                                <p>ES</p>
                                <img
                                  className="flag-image me-0"
                                  alt="Flag"
                                  src="/images/spain-flag.png"
                                />
                              </div>
                            ) : (
                              <div
                                className="language-switch-container cursor-pointer"
                                onClick={() => setCurrentLang("es")}
                              >
                                <img
                                  className="flag-image me-0"
                                  alt="Flag"
                                  src={Flag}
                                />
                                <p>EN</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </ul>
                    </Link>
                  </div>
                </div>

                {/* Logout Modal */}
                <Modal
                  show={showModal}
                  centered
                  className="newmodalui wrapper-modal asguarantor"
                >
                  <Modal.Header></Modal.Header>
                  <Modal.Body>
                    <div className="forminput forminput-btngrp row100">
                      Are you sure you want to logout?
                    </div>
                    <div className="btngroup row100 gridbar">
                      <button
                        className="btn btnoutline cancel-btn"
                        type="button"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btnorange"
                        type="button"
                        onClick={() => {}}
                      >
                        Logout
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>

                {/* Email Invitation Modal */}
                <Modal
                  show={showEmailModal}
                  onHide={() => setShowEmailModal(false)}
                  centered
                  className="newmodalui max-w-lg wrapper-modal"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Email</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form
                      onSubmit={(e) => e.preventDefault()}
                      className="d-flex flex-wrap mt-5 justify-content-center"
                    >
                      <div className="form-group col-6 px-1 bodyContentset">
                        <input
                          type="text"
                          onChange={(e) => setSharerName(e.target.value)}
                          value={sharerName}
                          className="form-control"
                          required
                          placeholder="Name"
                        />
                      </div>
                      <div className="form-group col-6 px-1 bodyContentset">
                        <input
                          type="email"
                          onChange={(e) => setSharerEmail(e.target.value)}
                          value={sharerEmail}
                          className="form-control"
                          required
                          placeholder="Email"
                        />
                      </div>
                      <div className="col-12 mt-3 d-flex justify-content-center">
                        <button type="submit" className="btn btngreen">
                          Send Invitation
                        </button>
                      </div>
                    </form>
                  </Modal.Body>
                </Modal>

                {/* Phone Invitation Modal */}
                <Modal
                  show={showPhoneModal}
                  onHide={() => setShowPhoneModal(false)}
                  centered
                  className="newmodalui max-w-lg wrapper-modal"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Phone</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form
                      onSubmit={(e) => e.preventDefault()}
                      className="d-flex flex-wrap mt-5 justify-content-center"
                    >
                      <div className="form-group col-6 px-1 bodyContentset">
                        <input
                          type="text"
                          onChange={(e) => setSharerName(e.target.value)}
                          value={sharerName}
                          className="form-control"
                          required
                          placeholder="Name"
                        />
                      </div>
                      <div className="form-group col-6 px-1 bodyContentset">
                        <PhoneInput
                          className="custom-input phone_input_info"
                          international
                          defaultCountry="es"
                          value={sharerPhone}
                          onChange={(e) =>
                            setSharePhone(e?.replace("+", "") || "")
                          }
                        />
                      </div>
                      <div className="col-12 mt-3 d-flex justify-content-center">
                        <button type="submit" className="btn btngreen">
                          Send Invitation
                        </button>
                      </div>
                    </form>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Nav */}
        <div className="hideOnDesktop mobileNav">
          <ul className="d-flex justify-content-evenly align-items-center">
            <li className="d-flex active flex-column align-items-center">
              <img src="/images/skor-report.svg" alt="" />
              Skor Report
            </li>
            <li
              className="d-flex active flex-column align-items-center"
              onClick={() => setIsShareProfileModal(true)}
            >
              <img src="/images/user-share.svg" alt="" />
              Share Profile
            </li>
            <li className="d-flex flex-column align-items-center">
              <img src="/images/notification-icon.svg" alt="" />
              Notifications
            </li>
          </ul>
        </div>

        {/* Share QR Modal */}
        <Modal
          show={shareQrModal}
          onHide={() => {
            setShareQrModal(false);
            setIsShareProfileModal(true);
          }}
          centered
          className="newmodalui qrModal wrapper-modal"
        >
          <img
            src={Cancelimg}
            alt="icon"
            onClick={() => {
              setShareQrModal(false);
              setIsShareProfileModal(true);
            }}
            className="canceicon topRightIcon"
          />
          <Modal.Body>
            <div className="qr-code-div">
              <QRCode
                id="qr_code_image"
                value="https://example.com/profile-request?sharedProfileLink=userId"
              />
            </div>
            <h4 className="text-center">Profile Link</h4>
            <p className="text-center">
              Share your profile link with Landlords & Agents
            </p>
            <div className="qrLinkCopyWrapper d-flex align-items-center justify-content-center">
              <div className="qr-link-copi">
                <input
                  type="text"
                  disabled
                  value="https://example.com/profile-request?sharedProfileLink=userId"
                />
                <button type="button">
                  <img src="/images/copy-icon.svg" alt="" />
                </button>
              </div>
              <a
                href={undefined}
                className="downloadButton d-flex align-items-center justify-content-center"
              >
                <img src="images/download-icon-green.svg" alt="" />
              </a>
            </div>
          </Modal.Body>
        </Modal>

        {/* Remove Share Modal */}
        <Modal
          show={showRemove}
          onHide={() => {
            setShowRemove(false);
            setIsShareProfileModal(true);
          }}
          centered
          className="newmodalui wrapper-modal"
        >
          <Modal.Header>
            <Modal.Title className="modal-type">
              Are you sure you want to stop sharing your Skor profile?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="btngroup row100 gridbar d-flex justify-content-between gap-3">
              <button
                className="btn cancel-btn btnoutline modal-cancel-btn"
                type="button"
                onClick={() => {
                  setShowRemove(false);
                  setIsShareProfileModal(true);
                }}
              >
                Cancel
              </button>
              <button
                className="btn btnorange modal-submit-btn"
                type="button"
                onClick={() => {}}
              >
                Remove
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Shared Success Modal */}
        <Modal
          show={showSharedModal}
          onHide={() => {
            setShowSharedModal(false);
            setIsShareProfileModal(true);
          }}
          centered
          className="newmodalui max-w-lg wrapper-modal newnaman"
        >
          <Modal.Body
            style={{ textAlign: "center" }}
            className="d-flex flex-column"
          >
            Success! Your Skor profile has been successfully shared.
            <button
              className="btn goBackBtn cursor-pointer"
              onClick={() => {
                setShowSharedModal(false);
                setIsShareProfileModal(true);
              }}
            >
              Go Back
            </button>
          </Modal.Body>
        </Modal>
      </nav>
    </>
  );
};

export default DummyHeader;
